<div class="field-dialog dialog-segments">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ segment.name || 'SEGMENTS.DIALOG.TITLE_NEW' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button aria-label="Close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content" [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="{{ 'SEGMENTS.GENERAL' | translate }}">
      <disclaimer *ngIf="isViewMode" [message]="'SEGMENTS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-general [generalForm]="generalForm"></tab-general>
    </mat-tab>

    <mat-tab label="{{ 'SEGMENTS.FORMS' | translate }}" [disabled]="!segment.id">
      <disclaimer *ngIf="isViewMode" [message]="'SEGMENTS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-forms
        [isViewMode]="isViewMode"
        [selectedSegment]="segment && segment.name ? segment : null"
        [segmentMaintenanceFormsArray]="segmentMaintenanceFormsArray"
        [isDuplicatedForm]="isDuplicatedForm"
      ></tab-forms>
    </mat-tab>

    <mat-tab label="{{ 'SEGMENTS.GROUPS' | translate }}" [disabled]="!segment.id" *ngIf="hasEditGroupPermission">
      <ng-template matTabContent>
        <disclaimer *ngIf="isViewMode" [message]="'SEGMENTS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
        <tab-groups [isViewMode]="isViewMode" [segment]="segment"></tab-groups>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ 'SEGMENTS.SETTINGS' | translate }}" [disabled]="!segment.id">
      <disclaimer *ngIf="isViewMode" [message]="'SEGMENTS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-settings
        #settingSlider
        [isViewMode]="isViewMode"
        [maintenanceTypesForm]="maintenanceTypesForm"
        [segment]="segment"
        (noMaintenancesSelectedChange)="onLinkMaintenanceTypesToSegmentChange($event)"
      ></tab-settings>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!isViewMode" class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      class="field-background"
      *ngIf="!segment.id && selectedTabIndex === 0; else saveButton"
      mat-raised-button
      [disabled]="generalForm?.invalid"
      (click)="continue()"
    >
      {{ 'SEGMENTS.DIALOG.BUTTON.CONTINUE' | translate }}
    </button>

    <ng-template #saveButton>
      <button
        class="field-background"
        data-cy="dialog-segments-save-button"
        mat-raised-button
        *ngIf="segment.id"
        [disabled]="isSaving || generalForm.invalid || segmentMaintenanceFormsArray.invalid || noMaintenancesSelected"
        (click)="saveSegment({ closeDialog: true })"
      >
        {{ 'SEGMENTS.DIALOG.BUTTON.SAVE' | translate }}
      </button>
    </ng-template>

    <button
      *ngIf="segment.id && !segment.archived"
      mat-icon-button
      class="archive-button"
      (click)="archiveOrUnarchiveSegment(true)"
      matTooltip="{{ 'SEGMENTS.DIALOG.BUTTON.ARCHIVE_SEGMENT' | translate }}"
      [disabled]="isSaving || generalForm.invalid || segmentMaintenanceFormsArray.invalid"
    >
      <mat-icon>archive</mat-icon>
    </button>

    <button
      *ngIf="segment.id && segment.archived"
      mat-icon-button
      class="archive-button"
      (click)="archiveOrUnarchiveSegment(false)"
      [disabled]="isSaving || generalForm.invalid || segmentMaintenanceFormsArray.invalid"
      matTooltip="{{ 'SEGMENTS.DIALOG.BUTTON.UNARCHIVE_SEGMENT' | translate }}"
    >
      <mat-icon>unarchive</mat-icon>
    </button>
  </div>
</div>
